module.exports = __webpack_public_path__ + "img/switch.25e553c2.svg";